import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {ApiProvider} from "../../providers/api/api";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {IntroWizardServiceProvider} from "../../providers/intro-wizard-service/intro-wizard-service";
import {AppModuleDetailsPage} from "../app-module-details/app-module-details";

/**
 * Generated class for the AppPartnerSelectionPopupPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-partner-selection-popup',
  templateUrl: 'app-partner-selection-popup.html',
})
export class AppPartnerSelectionPopupPage {

  code: string;
  errorVisible: boolean;
  introMode: boolean = true;
  codeFiltering: string = '';
  translationPrefix: string = '';

  constructor(public navCtrl: NavController, public navParams: NavParams, public loaderCtrl: LoadingController, public api: ApiProvider, public userState: UserStateProvider, public alertCtrl: AlertController, public contentTranslation: ContentTranslationProvider, public introWizard: IntroWizardServiceProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppPartnerSelectionPopupPage');

    if(this.userState.user) {
      this.introMode = false;
    }
    if(this.userState.user && this.userState.user.partnerSelected) {
      this.navCtrl.setRoot(AppDashboardPage);
    }


  }

  showInfoPopup() {
    var alert = this.alertCtrl.create({
      title: null,
      subTitle: this.contentTranslation.translateContent(this.translationPrefix + 'Modal partner code Problem Text'),
      buttons: [
        {
          text: this.contentTranslation.translateContent('OK').toUpperCase(),
        },
        {
          text: '×',
          cssClass: 'close-button'
        }],
      cssClass: 'ip-alert ip-with-close partner-info-popup password-forgotten-modal'
    });
    alert.present();
  }

  saveData(validate: boolean) {
    if(validate && !this.code) {
      this.errorVisible = true;
      return ;
    }

    if(this.navParams.get('paymentProcess')) {
      let loader = this.loaderCtrl.create();
      loader.present();

      this.api.callPost('/users/' + this.userState.user.id + '/validatePartnerCode', {code: this.code, filtering: this.codeFiltering}).subscribe((res: any) => {
        this.userState.user.locked = false;
        this.navCtrl.popToRoot();
        console.log('pop to root!');
        loader.dismissAll();
      }, () => {
        var alert = this.alertCtrl.create({
          title: this.contentTranslation.translateContent('Modal partner code Problem Title'),
          subTitle: this.contentTranslation.translateContent('Modal partner code Problem Text'),
          buttons: [
            {
              text: this.contentTranslation.translateContent('OK').toUpperCase(),
            }],
          cssClass: 'password-forgotten-modal'
        });
        alert.present();
        loader.dismissAll();
      })

      return ;
    }

    if(this.introMode) {
      if (validate) {
        let loader = this.loaderCtrl.create();
        loader.present();

        this.api.callPost('/validateInitPartnerCode', {code: this.code, filtering: this.codeFiltering}).subscribe((res: any) => {
          if(!res.status) {
            throw new Error("Status is false");
          }

          this.introWizard.partnerCode = this.code;
          this.introWizard.bgm = (res.bgm == true);
          this.introWizard.yuble = (res.yuble == true);
          if(res.bgm) {
            this.introWizard.insurer = 'BGM';
          }

          loader.dismissAll();
          this.navCtrl.pop();
        }, (res:any) => {

          if(res.error && !res.error.status && res.error.bgmUsed) {
            var alert = this.alertCtrl.create({
              title: this.contentTranslation.translateContent('Modal partner code Used Title'),
              subTitle: this.contentTranslation.translateContent('Modal partner code Used Text'),
              buttons: [
                {
                  text: this.contentTranslation.translateContent('OK').toUpperCase(),
                }],
              cssClass: 'password-forgotten-modal'
            });
            alert.present();
            loader.dismissAll();
            return ;
          } else {
            var alert = this.alertCtrl.create({
              title: this.contentTranslation.translateContent(this.translationPrefix + 'Modal partner code Problem Title'),
              subTitle: this.contentTranslation.translateContent(this.translationPrefix + 'Modal partner code Problem Text'),
              buttons: [
                {
                  text: this.contentTranslation.translateContent('OK').toUpperCase(),
                }],
              cssClass: 'password-forgotten-modal'
            });
            alert.present();
            loader.dismissAll();
          }
        });
      } else {
        this.introWizard.partnerCode = '';
        this.navCtrl.pop();
      }


    } else {
      if (validate) {
        let loader = this.loaderCtrl.create();
        loader.present();

        this.api.callPost('/users/' + this.userState.user.id + '/validatePartnerCode', {code: this.code, filtering: this.codeFiltering}).subscribe((res: any) => {
          console.log(res);

          if(res && res.data && res.data.id) {
            this.userState.user.partnerData = res.data;
          }

          loader.dismissAll();
          this.navCtrl.setRoot(AppDashboardPage);
        }, () => {
          var alert = this.alertCtrl.create({
            title: this.contentTranslation.translateContent('Modal partner code Problem Title'),
            subTitle: this.contentTranslation.translateContent('Modal partner code Problem Text'),
            buttons: [
              {
                text: this.contentTranslation.translateContent('OK').toUpperCase(),
              }],
            cssClass: 'password-forgotten-modal'
          });
          alert.present();
          loader.dismissAll();
        })
      } else {
        this.navCtrl.setRoot(AppDashboardPage);
        this.api.callPost('/users/' + this.userState.user.id + '/validatePartnerCode', {}).subscribe();
      }
    }
  }

  checkForEnter(e: KeyboardEvent) {
    this.errorVisible = false;
    console.log(e);
    if(e && e.keyCode === 13) {
      this.saveData(true);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-partner-selection-popup/app-partner-selection-popup.ts